import { ApiServiceBase } from './ApiServiceBase'

export default class extends ApiServiceBase {
  async new() {
    return useAsyncData('billing-new', () => this.call('/spa/billing/new'))
  }

  async show() {
    return useAsyncData('billing-show', () => this.call('/spa/billing/show'), {
      lazy: true,
      deep: false,
    })
  }

  async subscribeWithStripe(data: any): Promise<void> {
    return this.call('/spa/billing/subscribe', {
      method: 'post',
      body: data,
    })
  }

  async swap(data: any): Promise<void> {
    return this.call('/spa/billing/swap', {
      method: 'put',
      body: data,
    })
  }

  async validateCoupon(coupon: string): Promise<void> {
    return this.call('/spa/billing/coupon/validate', {
      method: 'post',
      body: {
        coupon,
      },
    })
  }

  async subscribeWithShopify(data: any): Promise<void> {
    return this.call('/spa/billing/shopify/subscribe', {
      method: 'post',
      body: data,
    })
  }

  async inAppSubscribe(hash: string): Promise<void> {
    return this.call('/spa/billing/inappsubscription/subscribe', {
      method: 'post',
      body: {
        subscription_hash: hash,
      },
    })
  }

  async inAppUnsubscribe(hash: string): Promise<void> {
    return this.call('/spa/billing/inappsubscription/unsubscribe', {
      method: 'post',
      body: {
        subscription_hash: hash,
      },
    })
  }
}
